export { default } from './ShelfListItem';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/index.js